export default __webpack_public_path__ + "locales/vi/EmptyTrashDialog.json?hash=bce49d505188f8c67970e59814589918";